import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

type Breadcrumb = {
	title?: string
	path?: string
	onClick?: () => void
}

interface BreadcrumbsProps {
	breadcrumbs: Breadcrumb[]
}

const BreadcrumbNav = styled.div`
	padding: 10px 5px 30px 5px;
	display: flex;
	flex-wrap: wrap;
`

const BreadcrumbList = styled.div`
	display: flex;
	list-style: none;
	flex-wrap: wrap;
	row-gap: 10px;
`

const BreadcrumbItem = styled.div`
	margin-right: 8px;
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 15px;
	color: #555;
	white-space: nowrap;
	cursor: pointer;
	overflow: hidden;
	text-overflow: ellipsis;

	@media (max-width: 630px) {
		max-width: 190px;
	}
`

const BreadcrumbsComponent = ({ breadcrumbs }: BreadcrumbsProps) => {
	return (
		<BreadcrumbNav>
			<BreadcrumbList>
				{breadcrumbs.map((breadcrumb, index) => (
					<React.Fragment key={index}>
						{index > 0 && <BreadcrumbItem>|</BreadcrumbItem>}

						{breadcrumb.path ? (
							<Link
								to={breadcrumb.path}
								onClick={e => {
									if (breadcrumb.onClick) {
										breadcrumb.onClick()
									}
								}}
							>
								<BreadcrumbItem>{breadcrumb.title}</BreadcrumbItem>
							</Link>
						) : (
							<BreadcrumbItem
								onClick={breadcrumb.onClick}
								style={{ cursor: breadcrumb.onClick ? 'pointer' : 'default' }}
							>
								{breadcrumb.title}
							</BreadcrumbItem>
						)}
					</React.Fragment>
				))}
			</BreadcrumbList>
		</BreadcrumbNav>
	)
}

export default BreadcrumbsComponent
